import { Box, BoxProps, useTheme } from '@mui/material'
import { FC, PropsWithChildren } from 'react'



interface CircleDivProps {
  size?: 'small' | 'medium' | 'large'
  boxProps?: BoxProps
}


export const CircleDiv: FC<PropsWithChildren<CircleDivProps>> = ({boxProps, size, children}) => {
  const theme =  useTheme()
  const backgroundColor = theme.palette.grey[200]
  const boxSize = size === 'large' ? 42 : size === 'medium' ? 32 : size === 'small' ? 24 : 32
  return (
    <Box
      component='div'
      sx={{
        borderRadius: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: backgroundColor,
        width: boxSize,
        height: boxSize,
        textAlign: 'center'
      }}
      {...boxProps}
    >
      {children}
    </Box>
  )

}